<template>
    <div v-if="showBox">
        <v-container class="buttons-margin-style" v-if="canEdit">
            <v-btn icon class="button-style" style="float: right;" @click="editAgente()" v-if="!editingState">
                <v-icon size="16"> mdi-pencil</v-icon>
            </v-btn>
        </v-container>
        <v-container class="buttons-margin-style-second" v-if="canEdit">
            <v-btn icon class="button-style" style="float: right;" @click="cancelEdit()" v-if="editingState">
                <v-icon size="16"> mdi-close</v-icon>
            </v-btn>

            <v-btn icon class="button-style" style="float: right;" @click="saveEdit()" v-if="editingState">
                <v-icon size="16"> mdi-content-save </v-icon>
            </v-btn>
        </v-container>


        <v-container class="pa-0 px-1 mt-0">
            <vs-list-item title="Agente: " :subtitle="editingState ? '' : agenteName"></vs-list-item>
            <v-form ref="formAgente">
                <v-autocomplete outlined class="px-1 pt-1" :items="agentItems" label="Seleccionar Agente"
                    item-value="Clave" item-text="Nombre" v-model="agentItemSelected" :rules="rules" v-if="editingState"
                    no-data-text="Introduzca un agente válido" @keypress.enter.prevent></v-autocomplete>
            </v-form>
        </v-container>
    </div>
</template>
<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import ReporteGeneral from '@/services/ReporteGeneral/ReporteGeneral.service.js';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";


export default {
    components: {
    },
    data() {
        return {
            showBox: false,
            canEdit: false,
            editingState: false,
            agenteName: "-",
            agentItems: [],
            agentItemSelected: null,

            rules: [
                v => !!v || 'Seleccione un agente',
            ],
        }
    },
    methods: {
        async getCanEdit() {
            try {
                let response = await ReporteGeneral.ObtenerCamposEdicionAgente();
                this.canEdit = response.puedeEditar;
                this.agenteName = response.nombreAgente;
                this.showBox = response.puedeVer;
                this.clclave = response.clclave;

                this.obtenerListadoAgentes();
            } catch (exp) {
                console.log("Exception:", exp);
                this.canEdit = false;
                this.showBox = false;
            }
        },

        async obtenerListadoAgentes() {
            try {
                let response = await ReporteGeneral.ObtenerListadoAgentes(this.clclave, "");
                this.agentItems = response;

            } catch (exp) {
                console.log("Exception:", exp);

            }
        },

        async editAgente() {
            this.editingState = true;
        },

        cancelEdit() {
            this.cleanEdit();
            this.editingState = false;
        },

        async saveEdit() {
            this.$refs.formAgente.validate();
            if (this.agentItemSelected == null || !this.$refs.formAgente.validate()) {
                return;
            }

            this.$swal({
                title: 'Cargando...',
                text: "Espere un momento, por favor",
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });

            let response = await ReporteGeneral.ActualizaAgenteReporte(this.agentItemSelected);
            await this.getCanEdit();
            this.$swal.close();
            if (response.exito == 1) {

                this.$swal({
                    position: "center",
                    icon: "success",
                    title: "Exito!",
                    html: "El campo se editó correctamente",
                    showConfirmButton: true,
                    timer: 5000,
                });
            } else {
                this.$swal({
                    position: "center",
                    icon: "error",
                    title: "Error al editar el campo",
                    html: "Ocurrió un error inesperado, intente de nuevo, si el problema persiste, contacte a soporte",
                    showConfirmButton: true,
                    timer: 5000,
                });
            }
            this.cancelEdit();
        },

        cleanEdit() {
            this.agentItemSelected = null;
        }

    },
    async mounted() {
        this.getCanEdit();
    }
}
</script>

<style scoped>
.buttons-margin-style {
    margin-bottom: -12px;
    margin-top: -5px;
    margin-left: -25px;
    position: absolute;
}

.buttons-margin-style-second {
    margin-bottom: -12px;
    margin-top: -10px;
    margin-left: -25px;
    position: absolute;
}

.button-style {
    height: 22px;
    width: 22px;
}
</style>